module.exports = __webpack_public_path__ + "static/media/profile-placeholder.14784500.png";